/**
 * Album art thumbnail naming convention -- shared between the upload handler
 * (server/routes/drafts.routes.ts, which generates the thumb file) and the
 * Vault grid (HHHistoryTab.tsx, which reads it). No DB column for the thumb
 * URL; it's always derivable from albumArtUrl/albumArtPath by convention,
 * matching the pattern already used for other derived URLs in this codebase.
 */

/** "1738012345-123.jpg" -> "1738012345-123-thumb.webp" */
export function toThumbFilename(filename: string): string {
  return filename.replace(/(\.[^./]+)$/, '-thumb.webp');
}

/** "/uploads/album-art/1738012345-123.jpg" -> "/uploads/album-art/1738012345-123-thumb.webp" */
export function getAlbumArtThumbUrl(albumArtUrl: string): string {
  return toThumbFilename(albumArtUrl);
}

/**
 * The URL a LIST should load for an album cover: the small thumbnail for our own uploads, and any other URL
 * (a Suno CDN image, an empty string) unchanged. A list of hundreds of songs must never load the full-size
 * originals (about 3.9 MB each); AUTO-083.
 */
export function getListArtUrl(url: string): string {
  if (!url.includes('/uploads/album-art/') || /-thumb\.webp(\?|$)/.test(url)) return url;
  return getAlbumArtThumbUrl(url);
}

